import { useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import Spinner from "components/base/Spinner";
import { useParams } from "react-router-dom";
import StockShipmentFormPage from "./StockShipmentFormPage";
import { FETCH_CREATE_STOCK_SHIPMENT_FORM_DATA } from "./graphql";

const CreateStockShipmentPage = () => {
  const { stockCategoryId } = useParams();
  const { loading, error, data } = useQuery(
    FETCH_CREATE_STOCK_SHIPMENT_FORM_DATA,
    {
      variables: { stockCategoryId },
      fetchPolicy: "network-only",
    },
  );

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const category = data?.stockCategory;
  const transferToOptions = data?.stockCategories || [];
  const stockCategoryLatestStocks = JSON.parse(
    data?.stockCategoryLatestStocks || "[]",
  );

  const productStocks = Object.values(stockCategoryLatestStocks).reduce(
    (stocks, { product_id, latest_qty }) => ({
      ...stocks,
      [product_id]: latest_qty,
    }),
    {},
  );

  return (
    <StockShipmentFormPage
      mode="create"
      stockCategoryId={category?.id || stockCategoryId}
      warehouseName={category?.name || ""}
      productStocks={productStocks}
      transferToOptions={transferToOptions}
    />
  );
};

export default CreateStockShipmentPage;
